<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="button-container">
          <el-button
            :loading="isGeneratingCSV"
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExportCSV"
          >
            Export CSV
          </el-button>
        </div>
      </div>

    </template>

  </sticky-header-layout>
</template>

<script>
import { generateRsPayoutsCSV } from '../../api/reports'
import fileDownload from '../../utils/file-download'
import useTablePaging from '../../mixins/useTablePaging'

export default {
  name: 'ExportRsPayoutReport',
  mixins: [useTablePaging],
  data() {
    return {
      isGeneratingCSV: false,
    }
  },
  computed: {
  },
  methods: {
    async handleExportCSV() {
      this.isGeneratingCSV = true
      // const payload = this.getPayload()
      try {
        const response = await generateRsPayoutsCSV()
        const isCSV = ['application/excel', 'application/csv'].includes(response.headers['content-type'])
        const { data } = response
        this.isGeneratingCSV = false
        if (!isCSV) {
          this.$alert(data.data.message, 'Success', {
            confirmButtonText: 'OK',
            type: 'warning',
          })
          return
        }
        fileDownload(data, 'rs_payout.csv')
      } catch (error) {
        this.isGeneratingCSV = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
